import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router';
// @mui
import { Box, BoxProps, Link } from '@mui/material';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useAuthContext } from 'src/auth/useAuthContext';
import { ApplicationType } from '../../@types/configuration';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  applicationType?: ApplicationType;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, applicationType = 'ALL', sx, ...other }, ref) => {
    const { isAuthenticated } = useAuthContext();

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 40,
          height: 40,
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path
            fill="#FA5D51"
            d="M2.5 21.5 9.849 6.741C11.139 4.211 12.511 3.682 13.999 6.824L19.599 18.771l1.338 2.874h-4.5L12 10.5 7 21.5H2.5z"
          />
        </svg>
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={RouterLink}
        to={isAuthenticated ? PATH_DASHBOARD.root : '/'}
        sx={{ display: 'contents' }}
      >
        {logo}
      </Link>
    );
  }
);

export default Logo;

Logo.displayName = 'Logo';
